export default {
    title: "Staff",
    tabs: {
        roles: "Roles",
        users: "Users",
        invitations: "Invitations"
    },
    invitations: {
        swalText: "Your invitation will be canceled.",
        table: {
            status: "Status"
        },
        paginatorText: 'invitations'
    },
    roles: {
        addRole: "Add Role",
        search: "Search Roles",
        table: {
            name: "Name",
            timesAssociated: "Times Associated",
            permissions: "Permissions"
        },
        fullAccess: "Full Access",
        paginatorText: "roles"
    },
    users: {
        addUser: "Add User",
        search: "Search Users",
        table: {
            firstName: "First Name",
            lastName: "Last Name",
            email: "Email",
            roles: "Roles"
        },
        paginatorText: 'users'
    },
    createUser: {
        title: "Send invitation",
        fields: {
            email: {
                label: "Email",
                placeholder: "Add User Email",
            },
            firstName: {
                label: "First Name",
                placeholder: "Add User First Name",
            },
            lastName: {
                label: "Last Name",
                placeholder: "Add User Last Name",
            },
            role: {
                label: "Role",
                placeholder: "Select Role",
            }
        },
        button: {
            create: "Send Invitation",
            cancel: "Cancel",
        },
        successMessage: 'Invitation has been successfully sent!'
    },
    acceptInvitation: {
        title: "Update profile",
        fields: {
            firstName: {
                label: "First Name",
                placeholder: "Add Your First Name",
            },
            lastName: {
                label: "Last Name",
                placeholder: "Add Your Last Name",
            },
            password: {
                label: "Password",
                placeholder: "Set Your Password",
            }
        },
        button: {
            update: "Update Profile and Accept Invitation",
        },
        successMessage: 'Invitation has been successfully accepted!',
        errorMessage: 'Invalid invitation.'
    },
    saveRole: {
        createTitle: "Create Role",
        updateTitle: "Update Role",
        backToLink: {
            text: "Back to",
            section: "roles and users"
        },
        fields: {
            name: {
                label: "Name",
                placeholder: "Add Role Name",
            },
            permissions: {
                label: "Permissions",
                placeholder: "Add Role Permissions",
            },
        },
        button: {
            create: "Add Role",
            update: "Update Role",
            cancel: "Cancel",
        },
        successMessage: 'Role has been successfully updated!'
    },
    saveUser: {
        updateTitle: "Update User",
        backToLink: {
            text: "Back to",
            section: "roles and users"
        },
        fields: {
            roles: {
                label: "Roles",
                placeholder: "Add User Roles",
            },
        },
        button: {
            update: "Update User",
            cancel: "Cancel",
        },
        successMessage: 'User roles has been successfully updated!'
    }
}
